import { DialogContent, DialogTitle, TextField } from "@mui/material";
import styles from "../tenantdetails.module.css";
import { ArrowLeft, X } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import { AddLogCallAPI } from "../../../components/AddLogs";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const schema = yup.object().shape({
    move_out_date: yup.date().required("This field is Required")
});

const MoveOutForm = ({ tenantId, tenantData, setTenantData, setShowMoveoutForm, setLoading, setSnackbarOpen, setSnackbarMsg }) => {
    const { getAccessTokenSilently } = useAuth0();

    const { handleSubmit, control, errors } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        let postData = { id: tenantId };

        if (data.move_out_date) {
            postData = { ...postData, move_out_date: dayjs(data.move_out_date).format("YYYY-MM-DD") };
        }

        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/move-out", postData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);
            setShowMoveoutForm(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setTenantData(prev => {
                return { ...prev, is_move_out: 1, is_archived: 1 };
            });

            let logData = {
                title: "Tenant has been moved out",
                description: [
                    "Name: " + tenantData[0]?.full_name,
                    "Phone: " + tenantData[0]?.phone,
                    "Property: " + tenantData?.property?.name,
                    "Apartment: " + tenantData?.apartment?.apt_no,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined") {
                toast.error(error.response.data?.message);
            }
        });
    }

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setShowMoveoutForm(false)}><ArrowLeft /></button>
            <span>{'Move Out'}</span>
            <button onClick={(e) => setShowMoveoutForm(false)}><X /></button>
        </DialogTitle>
        <DialogContent>            
            <div className={`${styles.ProfileCardEditSec}`}>
                <label class="PopupBodyText">Are you sure you want to move out the Tenant?</label>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className={`${styles.ProfileEditFormSec} ${styles.ProfileEditFirstSec}`}>
                            <div className={`${styles.EditFormFullSec} FormGroup`}>
                                <Controller
                                    name="move_out_date"
                                    control={control}
                                    render={(field) => (<DatePicker
                                        {...field}
                                        label="Move out date*"
                                        renderInput={(params) => (<TextField {...params} />)}
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />)}
                                />
                                {errors.move_out_date && (<p className={`${styles.ErrorM}`}>{errors.move_out_date.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.ButtonArea}`}>
                            <button className={`${styles.ButtonVoiletLine}`} type="button" onClick={(e) => setShowMoveoutForm(false)}>Cancel</button>
                            <button className={`${styles.ButtonVoiletSolid}`} type="submit">Submit</button>
                        </div>
                    </LocalizationProvider>
                </form>
            </div>
        </DialogContent>
    </>)
}


export default MoveOutForm;